<template lang="html">
  <div class="full-page">
    <i-header title="风险测评" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="risk-confirm">
        <div class="risk-confirm-by">
          <div class="risk-confirm-info">
            <div class="risk-confirm-info-level">
              <div class="risk-red-result">C1</div>
            </div>
            <div class="risk-confirm-info-tips">
              需确认您是否为最低风险承受能力的投资者（符合下列条件之一）
              <div class="risk-confirm-info-tips-item">1.不具有完全民事行为能力;</div>
              <div class="risk-confirm-info-tips-item">2.没有风险容忍度或者不愿承受任何投资损失;</div>
              <div class="risk-confirm-info-tips-item">3.法律、行政法规规定的其他情形;</div>
            </div>
          </div>
        </div>
        <div class="foot-btn confirm-btn">
          <cube-button @click="$_handleConfirm(1)">是</cube-button>
          <cube-button @click="$_handleConfirm(0)" class="danger-btn">否</cube-button>
        </div>
      </div>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getRiskQuestionsCal } from '../../api/risk';

export default {
  computed: {
    ...mapGetters(['riskResult', 'managerInfo', 'au']),
  },
  methods: {
    $_handleConfirm(type) {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      getRiskQuestionsCal({
        sysCode: this.managerInfo.sysCode,
        managerAdminUserId: this.managerInfo.managerAdminUserId,
        userId: this.managerInfo.invenstemUserId,
        answerJsonStr: this.riskResult.userAnswer,
        afterResult: type === 1 ? 'C1' : '风险承受最低类别',
      }, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          const riskResult = res.data.bean;
          this.$store.dispatch('changeRiskResult', riskResult)
            .then(() => {
              this.$router.push({
                path: '/risk/result',
              });
            });
        } else {
          this.$createToast({
            type: 'txt',
            txt: res.msg,
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.risk-confirm {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .risk-confirm-by {
    overflow: auto;
    padding-bottom: 30px;
    .risk-confirm-info {
      padding: 20px 17px;
      background: #fff;
      text-align: center;
      .risk-confirm-info-level {
        margin-bottom: 16px;
        .risk-red-result {
          display: inline-block;
          width: 88px;
          height: 88px;
          line-height: 88px;
          font-size: 32px;
          color: #ff3838;
          font-weight: bold;
          background-image: url('../../assets/star_red.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .risk-confirm-info-tips {
        text-align: left;
        .risk-confirm-info-tips-item {
          font-size: 13px;
          color: #666;
          padding-top: 15px;
          padding-left: 25px;
        }
      }
    }
  }
}
</style>
